import {
  getAddOnProduct,
  getAppProps,
  getMainProductQuantity,
  hex2a,
  isProductPage
} from './utils';
import { getDiscountOfferProduct, RENDER_TYPES } from './common/discountOffer';
import { prepareAddonDetails } from './getAddOnDetails';
const TRACKING_CODE = GA_TRACKING;
const TRACKER_NAME = 'upsellTracker';
let trackerRequired = false;

export const ANALYTIC_CATEGORIES = {
  Product: 'Upsell Product Page',
  Cart: 'Upsell Cart Page',
  Popup: 'Upsell Popup',
  DiscountOffer: 'Upsell Bundles',
  AddToCart: 'Add To Cart'
};

function getAnalyticsVariable() {
  return window[hex2a('6761')];
}

function sendVariablesData(prefix = '', addOnIds, eventCategory, isRemove) {
  const ga = getAnalyticsVariable();

  for (let addOnId in addOnIds) {
    // Get product from addon or from popups (if we dont' have)
    const addOnProduct =
      getAddOnProduct(addOnId, 'addons') ||
      getAddOnProduct(addOnId, 'popups') ||
      getDiscountOfferProduct(addOnId, RENDER_TYPES.All) ||
      getDiscountOfferProduct(addOnId, RENDER_TYPES.Collection) ||
      getDiscountOfferProduct(addOnId, RENDER_TYPES.Catalog);

    if (addOnProduct) {
      const productList =
        window.upsell.product &&
        window.upsell.product.details &&
        window.upsell.product.details.title;
      ga(`${prefix}ec:addProduct`, {
        id: addOnId,
        name: addOnProduct.title,
        price: addOnProduct.price,
        quantity: addOnIds[addOnId],
        variant: addOnProduct.variant
      });
      ga(`${prefix}ec:setAction`, isRemove ? 'remove' : 'add', {
        list: productList ? productList : 'cart'
      });
      ga(`${prefix}send`, {
        hitType: 'event',
        eventCategory,
        eventAction: isRemove ? 'Remove from Cart' : 'Add to Cart',
        eventLabel:
          window.upsell.product && window.upsell.product.details
            ? window.upsell.product.details.title.toString()
            : 'cart'
      });
    }
  }
  // ga(`${TRACKER_NAME}.ec:setAction`, 'purchase', {
  //   id: 'transactionId_123',
  //   revenue: '44.00',
  //   list: 'Test Main Product'
  // });
  // ga(`${TRACKER_NAME}.send`, {
  //   hitType: 'event',
  //   eventCategory: 'upsellPurchase',
  //   eventAction: 'purchase'
  // });
}

function setupTrackerAnalytics() {
  // analytics variable
  const ga = getAnalyticsVariable();

  if (!trackerRequired) {
    ga('create', hex2a(TRACKING_CODE), 'auto', TRACKER_NAME);
    ga(`${TRACKER_NAME}.require`, 'ec');
    trackerRequired = true;
  }
  ga(`${TRACKER_NAME}.set`, 'transport', 'beacon');
  ga(`${TRACKER_NAME}.set`, 'dataSource', Shopify.shop);
}

function isAnalyticsEnabled() {
  const { options } = getAppProps();

  // Skip analytics sending
  if (options.disableGaAnalytics) {
    return false;
  }

  return true;
}

function sendUpsellTrackerAnalytics(addOnIds, eventCategory, isRemove) {
  if (!isAnalyticsEnabled()) {
    return;
  }

  setupTrackerAnalytics();
  sendVariablesData(`${TRACKER_NAME}.`, addOnIds, eventCategory, isRemove);
}

function sendUserAnalytics(addOnIds, eventCategory, isRemove) {
  sendVariablesData(undefined, addOnIds, eventCategory, isRemove);
}

export default function analytics(addOnIds, eventCategory, isRemove) {
  if (!getAnalyticsVariable()) {
    return;
  }

  sendUpsellTrackerAnalytics(addOnIds, eventCategory, isRemove);
  sendUserAnalytics(addOnIds, eventCategory, isRemove);
}

export function sendAddToCartAnalytics() {
  if (!isProductPage()) {
    return;
  }

  const ga = getAnalyticsVariable();
  if (!ga) {
    return;
  }

  if (!isAnalyticsEnabled()) {
    return;
  }

  const prefix = `${TRACKER_NAME}.`;
  const eventCategory = ANALYTIC_CATEGORIES.AddToCart;

  const { options } = getAppProps();

  const url = new URL(document.URL);
  const variantIdStr = url.searchParams.get('variant');
  let variantId =
    typeof variantIdStr === 'string'
      ? parseInt(variantIdStr)
      : // eslint-disable-next-line no-undef
        upsell.product.details.variants[0].id;

  let variant = '';
  if (variantIdStr) {
    const variantInfo = window.upsell.product.details.variants.find(
      v => v.id === parseInt(variantIdStr)
    );
    if (variantInfo) {
      variant = variantInfo.title;
    }
  }

  const product = prepareAddonDetails({
    options,
    result: {
      // eslint-disable-next-line no-undef
      product: upsell.product.details
    },
    addOnRecord: {
      ids: [variantId]
    }
  });

  const quantity = getMainProductQuantity();

  setupTrackerAnalytics();

  // Send all data
  ga(`${prefix}ec:addProduct`, {
    id: product.id,
    name: product.title,
    price: product.price,
    quantity,
    variant
  });
  ga(`${prefix}ec:setAction`, 'add', {
    list: 'product'
  });
  ga(`${prefix}send`, {
    hitType: 'event',
    eventCategory,
    eventAction: 'Add to Cart',
    eventLabel: product.title
  });
}
